"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncTransaction = exports.useAsyncTransactionCallback = exports.useFirestoreTransaction = void 0;
const firestore_1 = require("firebase/firestore");
const react_1 = require("react");
const react_async_hook_1 = require("react-async-hook");
const reactfire_1 = require("reactfire");
function useFirestoreTransaction() {
    const firestore = (0, reactfire_1.useFirestore)();
    return (0, react_1.useCallback)((handler) => (0, firestore_1.runTransaction)(firestore, handler), [firestore]);
}
exports.useFirestoreTransaction = useFirestoreTransaction;
/**
 * Wrap function in a firestore transaction as callback
 *
 * @see https://github.com/slorber/react-async-hook
 * @param func
 * @param options
 */
function useAsyncTransactionCallback(func, options) {
    const firestore = (0, reactfire_1.useFirestore)();
    return (0, react_async_hook_1.useAsyncCallback)((...a) => (0, firestore_1.runTransaction)(firestore, (trans) => func(trans, ...a)), options);
}
exports.useAsyncTransactionCallback = useAsyncTransactionCallback;
/**
 * Wrap function in a firestore transaction as an async function
 *
 * @see https://github.com/slorber/react-async-hook
 * @param func
 * @param params
 */
function useAsyncTransaction(func, params) {
    const firestore = (0, reactfire_1.useFirestore)();
    return (0, react_async_hook_1.useAsync)((...a) => (0, firestore_1.runTransaction)(firestore, (trans) => func(trans, ...a)), params);
}
exports.useAsyncTransaction = useAsyncTransaction;
//# sourceMappingURL=firebase-misc-hooks.js.map